module.exports = __webpack_public_path__ + "static/media/hs_bolt_logo_orange.3b97e2cc.svg";